import {
    getInvoiceRouteIdLoading,
    getInvoiceRouteIdRequest,
    getInvoiceRouteIdSuccess,
    getInvoiceRouteIdReject,
} from "../../actions/invoice/getId";

export const getInvoiceRouteId = (formData) => async (dispatch, getState) => {
    dispatch(getInvoiceRouteIdLoading());
    try {
        const { data } = await getInvoiceRouteIdRequest(formData, getState);
        dispatch(getInvoiceRouteIdSuccess(data))
    } catch (error) {
        dispatch(getInvoiceRouteIdReject(error))
    }
    return Promise.resolve();
};